// extracted by mini-css-extract-plugin
export default {"cls1":"WIITNufLfPBVWxfzc9Ps","cls2":"KG6aDUB_4cn9kSEwrTz7 WIITNufLfPBVWxfzc9Ps"};